function handleAnotheArticleDetail() {
    handleAnotherArticle('article-detail', 'new-article');
    handleAnotherArticle("article-detail", 'another-article');
    handleAnotherArticle("article-page", 'article-item');
    handleAnotherArticle("article-page", 'another-article-item');
}

function handleAnotherArticle(id, class_) {
    const listAnotherArticle = $(`#${id} .${class_}`)

    listAnotherArticle.on("click", function () {
        window.location.href =
            listAnotherArticle[
                $(listAnotherArticle).index(this)
            ].attributes.href.value;
    });
}

function convertDate() {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];

    const listTime = $(".article-time");
    
    for (let i = 0; i < listTime.length; i += 1) {
        const date = listTime[i].attributes.time.value.slice(8, 10);
        const month = months[getMonth(listTime, i)];
        const year = listTime[i].attributes.time.value.slice(0, 4);
        listTime[i].innerHTML = `${date} ${month} ${year}`;
    }
}

function getMonth(list, index) {
    let result = list[index].attributes.time.value.slice(5, 7);
    if (result[0] == "0") {
        return Number(result[1] - 1);
    } else {
        return Number(result - 1);
    }
}

module.exports = { handleAnotheArticleDetail, convertDate };
